import { useApp } from '../../contexts/AppContext';
import './PlaceholderPage.css';

interface PlaceholderPageProps {
  title: string;
  icon?: string;
  componentPath?: string;
  config?: Record<string, unknown>;
}

export function PlaceholderPage({ title, icon, componentPath, config }: PlaceholderPageProps) {
  const { selectedProject, selectedUserGroup, allNamespaces } = useApp();

  return (
    <div className="placeholder-page">
      <div className="placeholder-header">
        {icon && (
          <div className="placeholder-icon">
            <i className={icon.replace(' fa-2x', '')}></i>
          </div>
        )}
        <h1 className="placeholder-title">{title}</h1>
      </div>

      <div className="placeholder-content">
        <div className="placeholder-info-card">
          <h2>Page Information</h2>
          <p>This is a placeholder for the <strong>{title}</strong> page.</p>
          
          {componentPath && (
            <div className="info-section">
              <h3>Component Path</h3>
              <code>{componentPath}</code>
            </div>
          )}

          {config && Object.keys(config).length > 0 && (
            <div className="info-section">
              <h3>Configuration</h3>
              <pre>{JSON.stringify(config, null, 2)}</pre>
            </div>
          )}
        </div>

        <div className="placeholder-context-card">
          <h2>Current Context</h2>
          
          <div className="context-item">
            <span className="context-label">Project</span>
            <span className="context-value">{selectedProject?._name || 'Not selected'}</span>
          </div>

          <div className="context-item">
            <span className="context-label">User Group</span>
            <span className="context-value">{selectedUserGroup?._name || 'Not selected'}</span>
          </div>

          <div className="context-item">
            <span className="context-label">Active Namespaces</span>
            <div className="namespaces-list">
              {allNamespaces.length > 0 ? (
                allNamespaces.map((ns, index) => (
                  <span key={index} className="namespace-tag">{ns}</span>
                ))
              ) : (
                <span className="no-namespaces">No namespaces</span>
              )}
            </div>
          </div>
        </div>

        <div className="placeholder-note">
          <i className="fas fa-info-circle"></i>
          <p>
            To implement this page, create a component at{' '}
            <code>src/pages/{componentPath}</code> and update the routing configuration.
          </p>
        </div>
      </div>
    </div>
  );
}

export default PlaceholderPage;





